import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Joi from 'joi';
import { omit } from 'lodash';
import Fa from 'react-fontawesome';
import { Field, reduxForm, SubmissionError } from 'redux-form';
import {
  FormGroup, ControlLabel, HelpBlock, Button,
} from 'react-bootstrap';
import NumberFormat from 'react-number-format';

import {
  updateAnnualSalesGoal,
} from '../../../Auth/AuthActions';

// Import Selectors
import {
  getUser,
} from '../../../Auth/AuthReducer';

class AnnualSalesGoal extends Component {
  constructor() {
    super();
    this.state = {
    };
    this.renderField = this.renderField.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(data) {
    return this.props.dispatch(updateAnnualSalesGoal(data))
      .then(
        () => {},
        (errors) => {
          let e = errors;
          if (errors.data) {
            e = errors.data;
          }
          throw new SubmissionError(e);
        },
      );
  }

  renderField({
    input, label, placeholder, className, meta: { touched, error },
    submitBtn,
  }) {
    const { submitting } = this.props;

    const validationState = touched && error ? 'error' : null;
    return (
      <FormGroup className={className} validationState={validationState}>
        <ControlLabel>{label}</ControlLabel>
        <div className="row">
          <div className="col-xs-8 col-sm-9">
            <NumberFormat
              className="form-control"
              thousandSeparator
              prefix="$"
              {...omit(input, ['onChange', 'onBlur'])}
              disabled={submitting}
              decimalScale={2}
              placeholder={(placeholder || label)}
              allowNegative={false}
              onValueChange={(v) => {
                this.props.change(input.name, v.floatValue || null);
              }}
            />
            {error && touched && <HelpBlock>{error}</HelpBlock>}
          </div>
          <div className="col-xs-4 col-sm-3 text-right">
            {submitBtn}
          </div>
        </div>
      </FormGroup>
    );
  }

  render() {
    const { handleSubmit, valid, submitting } = this.props;
    const submitBtn = (
      <Button type="submit" disabled={(!valid || submitting)}>
        {!submitting && <span>Update</span>}
        {submitting && <span><Fa name="spinner" spin /> Updating</span>}
      </Button>
    );

    return (
      <div>
        <form onSubmit={handleSubmit(this.handleSubmit)}>
          <Field
            name="annual_sales_goal"
            label="Annual Sales Goal"
            component={this.renderField}
            submitBtn={submitBtn}
          />
        </form>
      </div>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps(state) {
  const user = getUser(state);
  const annualSalesGoal = user.annual_sales_goal;
  const initialValues = { annual_sales_goal: annualSalesGoal };
  return {
    initialValues,
    annualSalesGoal,
  };
}

AnnualSalesGoal.propTypes = {
  dispatch: PropTypes.func.isRequired,
  initialValues: PropTypes.shape({}),
  annualSalesGoal: PropTypes.number,
  initialize: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  valid: PropTypes.bool.isRequired,
  change: PropTypes.func.isRequired,
};
AnnualSalesGoal.defaultProps = {
  annualSalesGoal: null,
  initialValues: {},
};
AnnualSalesGoal.contextTypes = {
};

const validate = (values) => {
  // Legacy constraints for reference:
  // const constraints = {
  //   annual_sales_goal: {
  //     presence: true,
  //     numericality: {
  //       greaterThan: 0,
  //     },
  //   },
  // };

  const schema = Joi.object({
    annual_sales_goal: Joi.number().greater(0).required().messages({
      'number.base': 'Annual sales goal must be a number',
      'number.greater': 'Annual sales goal must be greater than 0',
      'any.required': 'Annual sales goal is required',
    }),
  }).unknown(true);

  const { error } = schema.validate(values, { abortEarly: false });
  if (!error) return {};
  
  return error.details.reduce((acc, curr) => {
    if (!acc[curr.path[0]]) acc[curr.path[0]] = [];
    acc[curr.path[0]].push(curr.message);
    return acc;
  }, {});
};

const AnnualSalesGoalForm = reduxForm({
  form: 'userAnnualSalesGoalForm',
  validate,
})(AnnualSalesGoal);

export default connect(mapStateToProps)(AnnualSalesGoalForm);
